import { SignUpTranslation } from "@/AutoEnrollment/ui/autoEnrollmentTranslation"
import { handleErrors } from "@/Shared/ui/form"
import { OreCheckbox, OreHeading, OreInput, OreStack, OreText } from "@edenredespana/oreneta"
import { useEffect } from "react"
import { useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { RegisterForm } from "../hooks"
import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { LoginTranslation } from "../accountTranslation"
import { LegalDocumentType } from "@/Shared/domain"

export const BasicRegisterForm = (props:{downloadPublicDocument: (id: LegalDocumentType, name?: string) => Promise<void>}): JSX.Element => {
  const { t } = useTranslation()
  const { register, formState, watch, clearErrors, setValue } =
    useFormContext<RegisterForm>()
  const { errors } = handleErrors(formState)

  const watchPassword = watch('password')
  const watchPasswordRepeat = watch('passwordRepeat')
  const watchEmail = watch('email')
  const watchEmail_confirmation = watch('emailRepeat')
  const watchUserName = watch('username')
  // const isPasswordRepeatDirty = formState.dirtyFields.passwordRepeat

  const download = async () => {
     await props.downloadPublicDocument(LegalDocumentType.privacyPolicies, t(SignUpTranslation.form.data.acceptConditions.filename))
  }

  useEffect(() => {
    if (formState.errors.passwordRepeat && watchPassword === watchPasswordRepeat) {
      clearErrors('passwordRepeat')
    }
  }, [watchPassword, watchPasswordRepeat, formState.errors.passwordRepeat])

  useEffect(() => {
    if (formState.errors.emailRepeat && watchEmail === watchEmail_confirmation) {
      clearErrors('emailRepeat')
    }
  }, [watchEmail, watchEmail_confirmation, formState.errors.emailRepeat])

   useEffect(() => {
    if (formState.errors.username) {
      clearErrors('username')
    }
  }, [watchUserName])

  return (
    <>
    <OreStack placeContent="stretch" space="large">
      <OreHeading as="h2" size="headline-md">
        {t(LoginTranslation.register.basicForm.title)}
      </OreHeading>
      <OreInput
        {...register('name')}
        {...errors('name')}
        id="name"
        label={t(SignUpTranslation.form.data.name.label)}
        placeholder={t(LoginTranslation.register.registerForm.name)}
        required
        maxLength={20}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('surname1')}
          {...errors('surname1')}
          id="surname1"
          label={t(SignUpTranslation.form.data.surname1.label)}
          placeholder={t(LoginTranslation.register.registerForm.surname)}
          required
          maxLength={20}
        />
        <OreInput
          {...register('surname2')}
          {...errors('surname2')}
          id="surname2"
          label={t(SignUpTranslation.form.data.surname2.label)}
          placeholder={t(LoginTranslation.register.registerForm.surname2)}
          maxLength={20}
        />
      </OreStack>
      <OreInput
        {...register('username')}
        {...errors('username')}
        id="username"
        label={t(SignUpTranslation.form.data.username.label)}
        placeholder={t(LoginTranslation.register.registerForm.username)}
        legend={t(LoginTranslation.register.registerForm.userNameLegend)}
        required
        maxLength={50}
      />
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('email')}
          {...errors('email')}
          id="email"
          label={t(SignUpTranslation.form.data.email.label)}
          placeholder={t(LoginTranslation.register.registerForm.email)}
          required
           onInput={() => {
            setValue('emailRepeat', '')
            clearErrors('emailRepeat')
          }}
          maxLength={75}
        />
        <OreInput
          {...register('emailRepeat')}
          {...errors('emailRepeat')}
          id="emailRepeat"
          label={t(SignUpTranslation.form.data.repeatEmail.label)}
          type="email"
          placeholder={t(LoginTranslation.register.registerForm.email)}
          required
          maxLength={75}
        />
      </OreStack>
      <OreStack direction="row" space="large" placeContent="stretch" sameSize>
        <OreInput
          {...register('password')}
          {...errors('password')}
          id="password"
          label={t(SignUpTranslation.form.data.password.label)}
          type="password"
          legend={t(SignUpTranslation.form.data.password.legend)}
          maxLength={50}
          required
          onInput={() => {
            setValue('passwordRepeat', '')
            clearErrors('passwordRepeat')
          }}
        />
        <OreInput
          {...register('passwordRepeat')}
          {...errors('passwordRepeat')}
          id="passwordRepeat"
          label={t(SignUpTranslation.form.data.repeatPassword.label)}
          type="password"
          maxLength={50}
          required
        />
      </OreStack>
        <OreCheckbox
          id="acceptConditions"
          {...register('acceptConditions')}
          {...errors('acceptConditions')}
          label={
            <>
              {t(SignUpTranslation.form.data.acceptConditions.label)}{' '}
              <a
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                target="_blank"
                onClick={(e) => {
                  e.preventDefault()
                  download()
                }}
              >
                  {t(SignUpTranslation.form.data.acceptConditions.link)}
              </a>
            </>
          }
          required
        />
    </OreStack>
    <OreText>{t(formTranslation.common.requiredFields)}</OreText>
    </>
  )
}